<script lang="ts">
	import { previewModeActivated } from '$utils/sanityUtils';
	import PageComponent from './PageComponent.svelte';
	import PagePreview from './PagePreview.svelte';

	let { data } = $props();

	// TODO: integrate presentation visual editing into some other pages
</script>

{#if previewModeActivated}
	<!-- These have to be separate "if" statements (rather than using an "else") for tree shaking to work for some reason -->
	<PagePreview {data} />
{/if}
{#if !previewModeActivated}
	<PageComponent {data} />
{/if}
